if (!customElements.get('premium-internal-video')) {

class PremiumInternalVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.internal-video__play');
    this.soundButton = this.querySelector('.internal-video__sound-btn');
    this.timeline = this.querySelector('.internal-video__timeline');
    this.autoplay = this.dataset.autoplay === 'true';

    if (!this.video) return;

    this.bindEvents();
    if (this.autoplay) this.initIntersectionObserver();
  }

  bindEvents() {
    if (this.playButton) {
      this.playButton.addEventListener('click', () => this.togglePlay());
    }
    if (this.soundButton) {
      this.soundButton.addEventListener('click', () => this.toggleSound());
    }
    this.video.addEventListener('timeupdate', () => this.updateTimeline());
    this.video.addEventListener('play', () => this.classList.add('internal-video--playing'));
    this.video.addEventListener('pause', () => this.classList.remove('internal-video--playing'));
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.playVideo();
        } else {
          this.pauseVideo();
        }
      });
    }, { threshold: 0.5 });
    this.observer.observe(this);
  }

  playVideo() {
    // If sources have data-src instead of src (lazy load)
    const sources = this.video.querySelectorAll('source');
    let loaded = false;
    sources.forEach(source => {
      if (source.hasAttribute('data-src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
        loaded = true;
      }
    });
    if (loaded) this.video.load();
    this.video.play().catch(() => {});
  }

  pauseVideo() {
    this.video.pause();
  }

  togglePlay() {
    if (this.video.paused) {
      this.playVideo();
    } else {
      this.pauseVideo();
    }
  }

  toggleSound() {
    this.video.muted = !this.video.muted;
    if (this.video.muted) {
      this.classList.add('internal-video--muted');
    } else {
      this.classList.remove('internal-video--muted');
    }
  }

  updateTimeline() {
    if (this.timeline && this.video.duration) {
      const percentage = (this.video.currentTime / this.video.duration) * 100;
      this.timeline.style.setProperty('--completed', `${percentage}%`);
    }
  }
}

  customElements.define('premium-internal-video', PremiumInternalVideo);
}
